import { GetStaticPropsContext, InferGetStaticPropsType } from 'next';
import { useTranslation } from 'react-i18next';
import { getContactPage } from 'repos/contactPage';
import { getAllMenuPage } from 'repos/menu';

import ContactBlock from 'components/ContactBlock';
import SubscribeCTABlock from 'components/SubscribeCTABlock';
import Layout from 'components/layout';
import SEO from 'components/seo';

export default function ContactPage({
  contactPage,
  menuParams,
}: InferGetStaticPropsType<typeof getStaticProps>) {
  const { t } = useTranslation();

  return (
    <Layout menuParams={menuParams}>
      <SEO
        title={t('contact_us')}
        description={contactPage.fields.description}
      />
      <ContactBlock
        title={contactPage.fields.title}
        subtitle={contactPage.fields.subtitle}
        text={contactPage.fields.description}
      />

      <section className="bg-white py-32 text-center">
        <h2 className="mb-4 text-3xl font-extrabold uppercase tracking-wider">
          {t("our_office")}
        </h2>
        <div className="mx-auto mt-16 flex max-w-7xl flex-col items-center gap-16 px-6 lg:flex-row">
          <Office
            city={t("mtl_office_city")}
            address={t("mtl_office_address")}
            postalCode={t("mtl_office_postal_code")}
            state={t("office_state")}
            iframeSrc="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2796.43260158636!2d-73.56236652271508!3d45.50136953095643!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4cc91b1d9e8ae1a1%3A0x263eba960586a54f!2sApprentx!5e0!3m2!1sen!2sca!4v1723662604957!5m2!1sen!2sca"
          />
          <Office
            city={t("qc_office_city")}
            address={t("qc_office_address")}
            postalCode={t("qc_office_postal_code")}
            state={t("office_state")}
            iframeSrc="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2730.4745036662353!2d-71.29081442267429!3d46.814656442327546!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4cc91c733952f14b%3A0x450ca1cef0b03972!2sOTI%20Expertise!5e0!3m2!1sen!2sca!4v1723662617549!5m2!1sen!2sca"
          />
        </div>
      </section>

      <SubscribeCTABlock text={contactPage.fields.ctaText} />
    </Layout>
  );
}

function Office({
  city,
  address,
  postalCode,
  state,
  iframeSrc,
}: {
  city: string;
  address: string;
  postalCode: string;
  state: string;
  iframeSrc: string;
}) {
  return (
    <div className="flex w-full flex-col justify-center">
      <iframe
        src={iframeSrc}
        className="h-[300px] w-[350px] rounded-lg border  sm:w-[100%]"
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
      <div className="w-full text-left text-2xl">
        <p className="my-4 text-3xl font-bold">{city}</p>
        {address} <br />
        {`${city} (${state})`}
        <br />
        {postalCode}
      </div>
    </div>
  );
}

export async function getStaticProps({
  locale,
  preview,
}: GetStaticPropsContext) {
  const contactPage = await getContactPage({ locale, preview });
  const menuParams = await getAllMenuPage({ locale });

  return {
    props: { contactPage, menuParams },
  };
}
